
export const LIB_NAME = 'analytics'

export const ID = 'userId'

export const ANONID = 'anonymousId'

export const ERROR_URL = 'https://lytics.dev/errors/'